import { render, staticRenderFns } from "./AccountLogs.vue?vue&type=template&id=52557dde"
import script from "./AccountLogs.vue?vue&type=script&lang=js"
export * from "./AccountLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports